import {
  inviteInfoSchema,
  sessionSchema,
  staffInviteSchema,
  staffListSchema,
  staffMemberSchema,
  type CreateStaffRequest,
  type InviteInfo,
  type Session,
  type StaffInvite,
  type StaffList,
  type StaffMember,
} from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export const fetchStaff = (signal?: AbortSignal): Promise<StaffList> =>
  apiRequest('/staff', { schema: staffListSchema, signal })

export const createStaff = (payload: CreateStaffRequest): Promise<StaffInvite> =>
  apiRequest('/staff', { method: 'POST', body: payload, schema: staffInviteSchema })

export const reissueInvite = (id: string): Promise<StaffInvite> =>
  apiRequest(`/staff/${encodeURIComponent(id)}/invite`, { method: 'POST', body: {}, schema: staffInviteSchema })

export const setStaffEnabled = (id: string, enabled: boolean): Promise<StaffMember> =>
  apiRequest(`/staff/${encodeURIComponent(id)}/${enabled ? 'enable' : 'disable'}`, {
    method: 'POST',
    body: {},
    schema: staffMemberSchema,
  })

export const fetchInvite = (token: string, signal?: AbortSignal): Promise<InviteInfo> =>
  apiRequest('/auth/invite/info', { method: 'POST', body: { token }, schema: inviteInfoSchema, signal })

export const acceptInvite = (token: string, password: string): Promise<Session> =>
  apiRequest('/auth/invite/accept', { method: 'POST', body: { token, password }, schema: sessionSchema })
